import { NavLink } from "react-router-dom";
import { Home, Gamepad2, Flag, Wallet, User } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function MobileNav({ onConnect }) {
  const { user } = useAuth();
  const items = [
    { to: "/", label: "Lobby", icon: Home, end: true },
    { to: "/games/crash", label: "Games", icon: Gamepad2 },
    { to: "/leaderboard", label: "Race", icon: Flag },
    { to: user ? "/deposit" : null, label: "Wallet", icon: Wallet },
    { to: user ? "/dashboard" : null, label: user ? "Profile" : "Sign in", icon: User },
  ];
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 glass border-t border-white/10 grid grid-cols-5" data-testid="mobile-nav">
      {items.map(({ to, label, icon: Icon, end }) =>
        to ? (
          <NavLink key={label} to={to} end={end} data-testid={`mnav-${label.toLowerCase()}`}
            className={({ isActive }) => `flex flex-col items-center justify-center gap-1 py-2.5 text-[10px] ${isActive ? "text-amber-400" : "text-zinc-500"}`}>
            <Icon size={18} /> {label}
          </NavLink>
        ) : (
          <button key={label} onClick={onConnect} className="flex flex-col items-center justify-center gap-1 py-2.5 text-[10px] text-zinc-500" data-testid={`mnav-${label.toLowerCase().replace(/\s/g, "-")}`}>
            <Icon size={18} /> {label}
          </button>
        )
      )}
    </nav>
  );
}
